<div class="action-buttons-group">
  <div
    class="action-options"
    sui-radio-group
    [ngModel]="globalAction"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="onGlobalActionChange($event)"
  >
    <sui-radio value="copy">
      {{ "widget-actions.to-other-feeds.label-copy" | translate }}
    </sui-radio>
    <sui-radio value="move">
      {{ "widget-actions.to-other-feeds.label-move" | translate }}
    </sui-radio>
  </div>

  <div class="switch-datasource">
    <sui-checkbox [(ngModel)]="switchDatasource">
      {{ "widget-actions.to-other-feeds.label-switch-datasource" | translate }}
    </sui-checkbox>
  </div>
</div>

<div class="table-container">
  <table class="table table-bordered table-hover">
    <thead class="table-header-sticky">
      <tr>
        <th scope="col" class="col-widget-title">
          {{ "widget-actions.to-other-feeds.col-widget-title" | translate }}
        </th>
        <th scope="col" class="col-action">
          {{ "widget-actions.to-other-feeds.col-action" | translate }}
        </th>
        <th scope="col" class="col-destination">
          {{ "widget-actions.to-other-feeds.col-destination" | translate }}
        </th>
      </tr>
    </thead>

    <tbody>
      @for (widget of widgets; track widget; let i = $index) {
        <tr>
          <!-- Widget Title Column -->
          <td class="widget-title-cell">
            <div class="widget-title-content">
              <fa-icon
                [icon]="['fas', 'chart-bar']"
                class="widget-icon"
              ></fa-icon>
              <span class="widget-title">{{ widget.title }}</span>
            </div>
          </td>
          <!-- Action Column -->
          <td class="action-cell">
            <div class="action-display">
              <span class="action-badge">
                {{ getActionDisplayText(globalAction) }}
              </span>
            </div>
          </td>
          <!-- Destination Feeds Column (Rowspan) -->
          @if (i === 0) {
            <td
              [attr.rowspan]="widgets.length"
              class="destination-cell-rowspan"
            >
              <div class="destination-content">
                <sui-button
                  variant="primary"
                  [leadingIcon]="['fas', 'plus']"
                  class="picker-button"
                  (click)="openFeedPicker()"
                  >Select Feeds</sui-button
                >
                @if (selectedFeeds.length > 0) {
                  <div class="selected-objects-list">
                    @for (feed of selectedFeeds; track feed) {
                      <div class="selected-object-item">
                        <fa-icon
                          [icon]="['fas', 'rss']"
                          class="object-icon"
                        ></fa-icon>
                        <span class="object-name">{{ feed.title }}</span>
                        <sui-button
                          size="sm"
                          variant="danger"
                          [leadingIcon]="['fas', 'times']"
                          [iconOnly]="true"
                          ariaLabel="Remove"
                          (click)="removeFeed(feed.id)"
                        ></sui-button>
                      </div>
                    }
                  </div>
                }
                @if (selectedFeeds.length === 0) {
                  <div class="no-selection-message">
                    <fa-icon
                      [icon]="['fas', 'info-circle']"
                    ></fa-icon>
                    <span>{{
                      "widget-actions.to-other-feeds.no-selection-message"
                        | translate
                    }}</span>
                  </div>
                }
              </div>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</div>
